import React, { useState, useEffect } from 'react'

const Carousel = (props) => {
	const [containerAvailable, setContainerAvailable] = useState(null)
	const [isBeginning, setIsContainerBeginning] = useState(true)

	const scrollPosition = props.scrollPos ? props.scrollPos : 0

	useEffect(() => {
		const carouselContainer = document.querySelector(`#slider-container`)
		if (containerAvailable === null) {
			setContainerAvailable(carouselContainer)
			checkBeginning(carouselContainer.scrollLeft)
		}
	}, [containerAvailable])

	const SLIDE_DIRECTION = {
		next: 'Next',
		previous: 'Previous',
	}

	const slidePrev = () => {
		scrollSlide(SLIDE_DIRECTION.previous)
	}

	const slideNext = () => {
		scrollSlide(SLIDE_DIRECTION.next)
	}

	const scrollSlide = (directionType) => {
		if (directionType === SLIDE_DIRECTION.next) {
			containerAvailable.scrollLeft += scrollPosition
			checkBeginning(containerAvailable.scrollLeft + scrollPosition)
		} else if (containerAvailable && directionType === SLIDE_DIRECTION.previous) {
			containerAvailable.scrollLeft -= scrollPosition
			checkBeginning(containerAvailable.scrollLeft - scrollPosition)
		}
	}

	const checkBeginning = (distance: number | undefined) => {
		if ((distance || distance === 0) && distance < 1) {
			setIsContainerBeginning(true)
		} else {
			setIsContainerBeginning(false)
		}
	}

	return (
		<div className='converse-carousel-wrapper'>
			<div className='converse-carousel-container' id='slider-container'>
				{props.list.length > 0 &&
					props.list.map((item, i) => (
						<div className='slide' key={i}>
							{item}
						</div>
					))}
			</div>
			<div className='button-container'>
				<div className={`carousel-button ${isBeginning ? 'disabled' : ''}`} onClick={slidePrev}>
					<button className={`arrow left`}></button>
				</div>
				<div className={`carousel-button`} onClick={slideNext}>
					<button className='arrow right'></button>
				</div>
			</div>
		</div>
	)
}

export default Carousel



// WEBPACK FOOTER //
// ./src/containers/AboutPage/Carousel.js